import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// Permanent-delete confirmation dialog for an already-archived
// customer. Two-step destructive flow: archive first, then this
// dialog gates the final, irreversible delete. Extracted from
// Clients.jsx (Feb 2026, iter181).
export function PermanentDeleteDialog({
  client,
  onClose,
  onConfirm,
}) {
  return (
    <Dialog open={!!client} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="text-red-600">Permanently Delete Customer</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-600">
          Are you sure you want to permanently delete <strong>{client?.name}</strong>?
          This action cannot be undone. All associated data will be removed.
        </p>
        <div className="flex justify-end gap-2 mt-4">
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button variant="destructive" onClick={onConfirm} data-testid="btn-confirm-delete-client">
            Delete Permanently
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
